<script setup>
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import gql from 'graphql-tag'
import { useShared } from '#/useShared'
import { useHubspot } from 'src/composables/useHubspot'

const { sharedApolloClient } = useAnalyzer()
const { interpretErrorMessage } = useShared()
const email = ref(null)
const $toast = useToast({ position: 'bottom' })
const { identify } = useHubspot()

async function attemptSubmit () {
  try {
    if (!email.value || !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.value)) {
      $toast.open({ type: 'info', message: 'Bitte eine gültige E-Mail-Adresse eingeben!' })
    } else {
      const res = await sharedApolloClient.value.mutate({
        mutation: gql`
          mutation subscribeToNewsLetter ($email: String!) {
            subscribeToNewsLetter (email: $email) {
              success
              error
              updateReferrer
            }
          }
        `,
        variables: { email: email.value, referrer: document.referrer }
      })
      if (res.data && res.data.subscribeToNewsLetter && res.data.subscribeToNewsLetter.success) {
        $toast.open({ type: 'success', message: 'Vielen Dank für Ihr Interesse! Gerne informieren wir Sie über News rund ums Planen, Bauen und Entwickeln von morgen!' })
        identify({
          email: email.value,
          hs_lead_status: 'NEW',
          web_form_type: 'Newsletter Subscription Form',
          ...(res.data.subscribeToNewsLetter.updateReferrer ? { rp_source_url: document.referrer } : {})
        }, '/')
        email.value = null
      } else if (res.data.subscribeToNewsLetter.error === 'EMAIL_ALREADY_EXISTS') {
        $toast.open({ type: 'info', message: 'Ihre Emailadresse ist bereits bei uns registriert!' })
      } else {
        $toast.open({ type: 'warning', message: 'Leider haben wir ein Serverproblem auf unserer Seite festgestellt. Bitte kontaktiere uns auf hallo@raumpioniere.io, damit wir dieses rasch beheben können.' })
      }
    }
  } catch (e) {
    console.log(JSON.parse(JSON.stringify(e)))
    $toast.open({ type: 'warning', message: interpretErrorMessage(e) })
  }
}

</script>

<template lang="pug">
.sub-email--container
  .sub-email--title
    div Raumpionier werden &
    div informiert bleiben.
  .sub-email--input-box(@keyup.enter="attemptSubmit")
    input.sub-email--input(placeholder="Ihre Emailadresse eingeben" v-model="email" autocomplete="on" name="email")
    .sub-email--button(@click="attemptSubmit") Anmelden
</template>

<style scoped lang="sass">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus
  -webkit-transition-delay: 9999s !important
  transition-delay: 9999s !important
  color: white
  -webkit-text-fill-color: white
.sub-email--container
  display: flex
  @media screen and (min-width: 1024px)
    padding: 59px 0 59px
    align-items: center
    justify-content: space-between
  @media screen and (max-width: 1024px)
    padding: 6px 0 71px
    flex-direction: column
    justify-content: center
  .sub-email--title
    font-weight: 500
    line-height: 130%
    color: #FFFFFF
    @media screen and (min-width: 1024px)
      font-size: 34px
    @media screen and (max-width: 1024px)
      font-size: 24px
      margin-bottom: 30px
      padding-left: 20px
  .sub-email--input-box
    display: flex
    align-items: center
    @media screen and (min-width: 1024px)
    @media screen and (max-width: 1024px)
      width: 100%
    .sub-email--input
      background: transparent
      border-radius: 10px 0px 0px 10px
      height: 50px
      outline: none
      font-weight: 500
      line-height: 30px
      color: white
      border: 1px solid #FFFFFF
      @media screen and (min-width: 1100px)
        padding: 10px 25px
        min-width: 375px
      @media screen and (max-width: 1100px)
        padding: 10px
        width: 100%
      &::placeholder
        font-weight: 500
        line-height: 30px
        color: v-bind(inputColor) !important
        @media screen and (min-width: 1100px)
          font-size: 16px
          color: white
        @media screen and (max-width: 1100px)
          font-size: 16px
    .sub-email--button
      cursor: pointer
      height: 50px
      background: #FFFFFF
      border: 1px solid #FFFFFF
      backdrop-filter: blur(5px)
      border-radius: 0px 10px 10px 0px
      font-weight: 500
      line-height: 30px
      color: #2B3341
      display: flex
      justify-content: center
      align-items: center
      @media screen and (min-width: 1024px)
        padding: 10px 25px
        font-size: 16px
      @media screen and (max-width: 1024px)
        padding: 10px 10px
        font-size: 14px
</style>
